import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from './App';

//pages
import FlipBoxAnimated from './components/FlipBoxAnimated';
import WhoWeAre from './pages/WhoWeAre';
import WhatWeDo from './pages/WhatWeDo';
import OurValues from './pages/OurValues';
import VisionAndMission from './pages/VisionAndMission';

import BrightIdeas from './pages/BrightIdeas';
import Careers from './pages/Careers';
import Contact from './pages/Contact';
import DigitalMarketing from './pages/DigitalMarketing';


import TravelTourismB2B from './pages/TravelTourismB2B';
import TravelTourismFinance from './pages/TravelTourismFinance';
import GDSPATools from './pages/GDSPATools';
import PackageManagementDis from './pages/PackageManagementDis';
import TravelTourismB2C from './pages/TravelTourismB2C';
import TravelTourismCorpPortal from './pages/TravelTourismCorpPortal';
import ExpenseManagement from './pages/ExpenseManagement';
import NDC from './pages/NDC';
// import ContractManDistribution from './pages/ContractManDistribution';
import FlightInventoryManagement from './pages/FlightInventoryManagement';
import AgentCMS from './pages/AgentCMS';
import DevOpsConsultingServices from './pages/DevOpsConsultingServices';
import WebsiteSoftwareDevelopment from './pages/WebsiteSoftwareDevelopment';
import ITConCloudServerManagement from './pages/ITConCloudServerManagement';
import BusinessProcessOutsourcing from './pages/BusinessProcessOutsourcing';
import MobileAppDevServices from './pages/MobileAppDevServices';
import RoboticProcessAutomation from './pages/RoboticProcessAutomation';
import HealthcareHyperautomation from './pages/HealthcareHyperautomation';
import NoPage from './pages/NoPage';
import PdfViewer from './components/PdfViewer';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <BrowserRouter>
      <Routes> 
      <Route path="/flipbox" element={<FlipBoxAnimated/>} />     
        <Route path="/" element={<Home/>} />
        <Route path="/who-we-are" element={<WhoWeAre/>} />
        <Route path="/what-we-do" element={<WhatWeDo/>} />
        <Route path="/our-values" element={<OurValues/>} />
        <Route path="/vision-and-mission" element={<VisionAndMission/>} />
        
        <Route path="/digital-marketing" element={<DigitalMarketing/>} />
        <Route path="/devOps-consulting-services" element={<DevOpsConsultingServices/>} />
        <Route path="/website-and-software-development" element={<WebsiteSoftwareDevelopment/>} />
        <Route path="/it-consulting-cloud-server-management" element={<ITConCloudServerManagement/>} />
        <Route path="/business-process-outsourcing" element={<BusinessProcessOutsourcing/>} />
        <Route path="/mobile-app-services" element={<MobileAppDevServices/>} />
        
        <Route path="/travel-tourism-b2b" element={<TravelTourismB2B/>} />
        <Route path="/travel-tourism-finance" element={<TravelTourismFinance/>} />
        <Route path="/gds-process-automation-tools" element={<GDSPATools/>} />
        <Route path="/package-management-distribution" element={<PackageManagementDis/>} />
        <Route path="/travel-tourism-b2c" element={<TravelTourismB2C/>} />
        <Route path="/travel-tourism-corporate-booking-portal" element={<TravelTourismCorpPortal/>} />
        <Route path="/expense-management" element={<ExpenseManagement/>} />
        <Route path="/ndc" element={<NDC/>} />
        {/* <Route path="/contract-management-distribution" element={<ContractManDistribution/>} /> */}
        <Route path="/flight-inventory-management-system" element={<FlightInventoryManagement/>} />
        <Route path="/robotic-process-automation" element={<RoboticProcessAutomation/>} />
        <Route path="/healthcare-hyperautomation" element={<HealthcareHyperautomation/>} />
        
        <Route path="/bright-ideas" element={<BrightIdeas/>} />
        <Route path="/careers" element={<Careers/>} />
        <Route path="/contact" element={<Contact/>} />
        <Route path="/agent-cms" element={<AgentCMS/>} />      

        <Route path="/b-commerce" element={<PdfViewer pdfUrl={'/pdf/b-commerce.pdf'} />} />
        <Route path="/s-bcommerce" element={<PdfViewer pdfUrl={'/pdf/s-bcommerce.pdf'} />} />
        <Route path="/b-whatsapp" element={<PdfViewer pdfUrl={'/pdf/b-whatsapp.pdf'} />} />

        <Route path="*" element={<NoPage />} />


      </Routes>

    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
